var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 20,
    className: "arrow",
    stroke: "#fa372c",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "rotate(287, 400, 400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 249.65908813476562Q253 564.6590881347656 550 549.6590881347656 ",
    markerEnd: "url(#marker)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    markerWidth: 10,
    markerHeight: 10,
    refX: 5,
    refY: 5,
    viewBox: "0 0 10 10",
    orient: "auto",
    id: "marker"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "0,5 5,2.5 0,0",
    fill: "none",
    strokeWidth: 1.6666666666666667,
    className: "arrow",
    stroke: "#fa372c",
    strokeLinecap: "round",
    transform: "matrix(1,0,0,1,1.6666666666666667,2.5)",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow1);
export default __webpack_public_path__ + "static/media/red-arrow-1.2f0173919946b88e84d4ba8a735114f4.svg";
export { ForwardRef as ReactComponent };